import { ReactNode } from "react";
import Answered from "@/components/Answered";
import ChatBubble from "@/components/ChatBubble";
import Page from "@/components/Page";
import Visible from "@/components/Visible";
import styles from "@/pages/Pages.module.scss";
import { PRICING_URL } from "@/constants";

type Props = {
  children?: ReactNode;
  variant?: "A" | "B";
};

export default function ObesityRecommendationContent({
  children,
  variant = "A",
}: Props) {
  const existingTreatmentQuestionId = "q5";

  return (
    <Page>
      <div className="mb-30">
        <ChatBubble>
          Hej, jag heter Qim och jag är verksamhets&shy;chef på Friska.
        </ChatBubble>
      </div>

      <Answered affirmative to={existingTreatmentQuestionId}>
        <Visible when={variant === "A"}>
          <ExistingTreatmentInfoVariantA />
        </Visible>
        <Visible when={variant === "B"}>
          <ExistingTreatmentInfoVariantB />
        </Visible>
      </Answered>

      <Answered negative to={existingTreatmentQuestionId}>
        <NewTreatmentInfo />
      </Answered>

      <p className={styles.noCommitment}>
        Ingen bindningstid — avsluta när som helst
      </p>

      {children}

      <div className={styles.additionalInfo}>
        <strong>Tänk på att</strong>
        <ul>
          <li>
            <a href={PRICING_URL} target="_blank">
              Kostnad för utredning tillkommer innan påbörjad behandling
            </a>
          </li>
          <li>Kostnader för läkemedel tillkommer</li>
          <li>
            Vår överviktsbehandling är idag inte utformad för att hjälpa
            personer med hjärt-njursvikt, inflammatorisk tarmsjukdom, pågående
            cancerbehandling, insulinbehandlad diabetes eller under tiden som du
            är gravid.
          </li>
        </ul>
      </div>
    </Page>
  );
}

const NewTreatmentInfo = () => {
  return (
    <>
      <h1>Starta din överviktsbehandling</h1>

      <p>
        Tack för dina svar! Nu behöver du bara logga in med BankID för att
        skicka in dem.
      </p>

      <p>
        Friska är en registrerad svensk vårdgivare. BankID krävs för trygg och
        säker identifiering.
      </p>

      <p>Du förbinder dig inte till något och kan avsluta när du vill. </p>
    </>
  );
};

const ExistingTreatmentInfoVariantA = () => {
  return (
    <>
      <h1>Fortsätt din överviktsbehandling hos oss</h1>

      <p>
        Tack för dina svar! Nu behöver du bara logga in med BankID för att
        skicka in dem.
      </p>

      <p>
        Friska är en registrerad svensk vårdgivare. BankID krävs för trygg och
        säker identifiering.
      </p>

      <p>Du förbinder dig inte till något och kan avsluta när du vill. </p>
    </>
  );
};

const ExistingTreatmentInfoVariantB = () => {
  return (
    <>
      <h1>Skicka in dina svar</h1>
      <p>
        Tack för dina svar. Nu behöver du bara logga in med BankID för att
        skicka in dem. Friska är en registrerad svensk vårdgivare. BankID krävs
        för trygg och säker identifiering.
      </p>
    </>
  );
};
